/**
*  Apply functions sequentially
*/

function applyFunctions(param, functions) {
  return functions.reduce((acc, func) => func(acc), param);
}

export default applyFunctions;
